import React, { FC, useMemo } from 'react';

import DatasetComponentView from './components/DatasetComponentView';
import DatasetNoComponentView from './components/DatasetNoComponentView';
import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

import useDatasetByIdQuery from '../../../hooks/datasets/useDatasetByIdQuery';
import useDatasetColumnComponentTypesQuery from '../../../hooks/datasets/useDatasetColumnComponentTypesQuery';

import { DatasetFieldModel } from '../../../models/dataset.model';
import { AlternateHeaderChildrenType } from '../../../models/formula.model';

interface FormulaAlternateDatasetViewProps {
    data: AlternateHeaderChildrenType;
    wrapText?: boolean;
}
const FormulaAlternateDatasetView: FC<FormulaAlternateDatasetViewProps> = ({
    data,
    wrapText,
}) => {
    const datasetId = useMemo<number>(() => +data.datasetId!, [data]);

    const datasetField = useMemo<number>(() => +data?.datasetField!, [data]);

    const { data: dataset } = useDatasetByIdQuery(datasetId);

    const { data: columnComponentTypes } =
        useDatasetColumnComponentTypesQuery(datasetId);

    const hasComponent = useMemo<boolean>(
        () => !!columnComponentTypes?.[datasetField],
        [columnComponentTypes, datasetField],
    );

    const columnNameMapping = useMemo<Record<number, string>>(
        () =>
            (dataset?.fields ?? []).reduce(
                (acc: Record<number, string>, curr: DatasetFieldModel) => {
                    acc[curr.id] = curr.name;
                    return acc;
                },
                {},
            ),
        [dataset],
    );

    return (
        <Content>
            {hasComponent ? (
                <DatasetComponentView
                    datasetId={datasetId}
                    datasetField={datasetField}
                    columnNameMapping={columnNameMapping}
                    wrapText={wrapText}
                />
            ) : (
                <DatasetNoComponentView
                    datasetId={datasetId}
                    datasetName={dataset?.name ?? ''}
                    datasetField={datasetField}
                    columnNameMapping={columnNameMapping}
                    wrapText={wrapText}
                />
            )}
        </Content>
    );
};

const Content = styled.div({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderLeft: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});

export default FormulaAlternateDatasetView;
